import React from 'react';
import { UserBadgeStack } from '@/components/shared';

export const LearningTimeModal: React.FC = () => {
  return (
<div className='modal-body'>
  <section className="modal-learning-table table-responsive">
    <table className='table table-striped'>
      <thead>
        <tr>
          <th>Skill</th>
          <th>Source</th>
          <th>Assignees</th>
          <th>Time to Master</th>
          <th>Time Assigned</th>
          <th>Review</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Identifies story elements</td>
          <td>Rollover</td>
          <td><UserBadgeStack students={["Bill Howard", "Annette Columns", "Alex Flowers", "Jessica Monroe"]}/></td>
          <td><span className="d-block px-3 py-1 border-rounded">0 mins</span></td>
          <td><span className="d-block px-3 py-1 border-rounded">12 mins</span></td>
          <td><a className=""></a>Already mastered</td>
        </tr>
        <tr>
          <td>Identify schwa</td>
          <td>Rollover</td>
          <td><UserBadgeStack students={["Dallas Jenkins", "Bob Dylan"]}/></td>
          <td><span className="d-block px-3 py-1 border-rounded">0 mins</span></td>
          <td><span className="d-block px-3 py-1 border-rounded">5 mins</span></td>
          <td>Review</td>
        </tr>
      </tbody>
    </table>
  </section>
</div>
  );
}